import { useTranslation } from 'react-i18next';

export default function ClashRewardModal({ reward, onClose }) {
  const { t } = useTranslation('zodiacClash');
  if (!reward) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={t('rewardLabel')}
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'rgba(10,0,30,0.82)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'linear-gradient(135deg,#1a0050,#0d0030)',
          border: '1.5px solid rgba(218,165,32,0.7)',
          borderRadius: 18,
          padding: '28px 24px',
          maxWidth: 340,
          width: '100%',
          textAlign: 'center',
          color: '#FFE9A6',
          boxShadow: '0 0 40px rgba(218,165,32,0.35)',
        }}
      >
        <div style={{ fontSize: 42, marginBottom: 8 }}>⚔️✨</div>

        <div style={{ fontWeight: 900, fontSize: 20, color: '#FFD700', marginBottom: 6 }}>
          {t('clashComplete')}
        </div>

        <div style={{ fontSize: 13, marginBottom: 16, lineHeight: 1.5, opacity: 0.92 }}>
          {reward.insight}
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginBottom: 20 }}>
          <div
            style={{
              background: 'rgba(218,165,32,0.18)',
              border: '1px solid rgba(218,165,32,0.5)',
              borderRadius: 10,
              padding: '6px 14px',
              fontWeight: 800,
              fontSize: 13,
            }}
          >
            +{reward.xpGranted} XP
          </div>

          <div
            style={{
              background: 'rgba(120,80,220,0.22)',
              border: '1px solid rgba(160,120,255,0.5)',
              borderRadius: 10,
              padding: '6px 14px',
              fontWeight: 800,
              fontSize: 13,
            }}
          >
            +1 {t('hint')} 💡
          </div>
        </div>

        <button
          type="button"
          onClick={onClose}
          style={{
            background: 'linear-gradient(135deg,#DAA520,#FFD700)',
            color: '#1a0050',
            border: 'none',
            borderRadius: 10,
            padding: '10px 28px',
            fontWeight: 900,
            fontSize: 15,
            cursor: 'pointer',
          }}
        >
          {t('continueClash')}
        </button>
      </div>
    </div>
  );
}
